export { default } from "./AccountDetail";
